import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from "@angular/core";

export interface SearchLinkData {
  name: string;
  link: string;
  [key: string]: any;
}

@Component({
    selector: 'app-search-link',
    templateUrl: './search-link.component.html',
    styleUrls: ['./search-link.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SearchLinkComponent {
  @Input() isLoading: boolean = false;
  @Input() data: SearchLinkData[] = [];
  @Input() dataSearch: SearchLinkData[] = [];
  @Input() placeholder: string = '';
  @Input() loadingPlaceholder: string = 'SEARCH_LINK.DATA_LOADING';
  @Input() filterByKey: string = '';

  @ViewChild('search') searchRef: ElementRef;

  public clearInputValue(): void {
    this.searchRef.nativeElement.value = '';
    this.onSearch('');
  }

  public onSearch(searchValue: string): void {
    this.dataSearch = this.getFilteredBySearch(this.data, searchValue);
  }

  public getFilteredBySearch(
    items: SearchLinkData[],
    value: string,
  ): SearchLinkData[] {
    if (!value.length) {
      return items;
    }
    return items.filter((item) =>
      item[this.filterByKey].toLowerCase().includes(value.toLowerCase()),
    );
  }

  public trackByItem(index: number, item: SearchLinkData): SearchLinkData {
    return item;
  }
}
